import React from 'react'
import { useTranslation } from 'react-i18next'
import { IVoltLicenseData } from '@cbgms/api/support'
import { Checkbox, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import { NullableDate } from './date.d'
import HaynesProLicensesTableRow from './HaynesProLicensesTableRow'

interface IPropsLicenseTable {
  rows: IVoltLicenseData[]
  startDate: NullableDate
  endDate: NullableDate
  rowSelections: Map<string, boolean>
  setRowSelections: (rowSelections: Map<string, boolean>) => void
}

const HaynesProLicensesTable: React.FC<IPropsLicenseTable> = ({ startDate, endDate, rows, rowSelections, setRowSelections }) => {
  const { t } = useTranslation()

  const selectAllRows = (value: boolean) => {
    setRowSelections(new Map(rows.map(row => [row.LicenseID, value])))
  }

  if (rows.length === 0) {
    return null
  }

  return (
    <TableContainer component={Paper} sx={{ mt: 1 }} data-testid='haynespro-licenses-table'>
      <Table size='small'>
        <TableHead>
          <TableRow>
            <TableCell padding='checkbox'>
              <Checkbox
                color='primary'
                checked={Array.from(rowSelections).every(([_, selected]) => selected)}
                onChange={event => {
                  selectAllRows(event.target.checked)
                }}
                data-testid='checkbox-select-all-licenses'
              />
            </TableCell>
            <TableCell>{t('haynespro.cell_license_id')}</TableCell>
            <TableCell>{t('haynespro.cell_license_product_type')}</TableCell>
            <TableCell>{t('haynespro.cell_license_clientid')}</TableCell>
            <TableCell>{t('haynespro.cell_license_reseller_name')}</TableCell>
            <TableCell>{t('haynespro.cell_company_description')}</TableCell>
            <TableCell>{t('haynespro.cell_shop_description')}</TableCell>
            <TableCell>{t('haynespro.cell_license_begin_date')}</TableCell>
            <TableCell>{t('haynespro.cell_license_end_date')}</TableCell>
            <TableCell>{t('hanyespro.cell_date_sparkline')}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows?.map(row => (
            <HaynesProLicensesTableRow
              row={row}
              key={row.LicenseID}
              startDate={startDate}
              endDate={endDate}
              selected={rowSelections.get(row.LicenseID) || false}
              setSelected={newSelectedValue =>
                setRowSelections(
                  new Map(
                    Array.from(rowSelections).map(([licenseID, existingSelectedValue]) => [
                      licenseID,
                      licenseID === row.LicenseID ? newSelectedValue : existingSelectedValue
                    ])
                  )
                )
              }
            />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default HaynesProLicensesTable
